import * as Actions from '../actions';
import React from 'react';
import { Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

const initialState = {
    quizNotGradedList:       [],
    assignmentNotGradedList: [],
    eventNotGradedList:      [],
    agenda:                  [],
    agenda_course_list:      [],
    current_course_id:       0,
    selfPacedCourses: [],
    newUserList: [],
    failedEventsList: []
};

const widgetsReducer = function (state = initialState, action) {
    switch ( action.type )
    {

        case(Actions.GET_QUIZ_NOT_GRADED_LIST):
        {
            return {
                ...state,
                quizNotGradedList: action.payload
            }
        }

        case(Actions.GET_ASSIGNMENT_NOT_GRADED_LIST):
        {
            return {
                ...state,
                assignmentNotGradedList: action.payload
            }
        }

        case(Actions.GET_EVENT_NOT_GRADED_LIST):
        {
            return {
                ...state,
                eventNotGradedList: action.payload
            }
        }

        case(Actions.GET_STUDENT_AGENDA):
        {
            const agenda = action.payload.map((event) => {
                if(event.quiz_id) {
                    return {
                        ...event,
                        title: <Link to={`/quiz/student/${event.company_calendar_event_id}`}>{event.title}</Link>

                    }
                }

                if(event.assignment_id) {
                    return {
                        ...event,
                        title: <Link to={`/assignment/student/${event.company_calendar_event_id}`}>{event.title}</Link>
                    }
                }
            });

            return {
                ...state,
                agenda: agenda
            }
        }

        case(Actions.GET_AGENDA):
        {
            const agenda = action.payload.map((event) => {
                return {
                    ...event,
                    title: <Link to={`/grade/student/list/${event.company_calendar_event_id}`}>{event.title}</Link>
                }
            });

            return {
                ...state,
                agenda: agenda
            }
        }

        case(Actions.GET_AGENDA_COURSE_LIST):
        {
            let agenda_course_list = action.payload;

            return {
                ...state,
                agenda_course_list: agenda_course_list,
            }
        }

        case(Actions.SET_CURRENT_COURSE_ID):
        {
            return {
                ...state,
                current_course_id: action.payload
            }
        }

        case (Actions.GET_SELF_PACED_COURSES):
        {
            return {
                ...state,
                selfPacedCourses: action.payload
            }
        }

        case (Actions.GET_NEW_USER_LIST):
        {
            return {
                ...state,
                newUserList: action.payload
            }
        }

        case(Actions.GET_FAILED_EVENTS):
        {
            return {
                ...state,
                failedEventsList: action.payload
            }
        }
        case(Actions.RETAKE_APPROVE):
        {
            return {
                ...state,
                failedEventsList: state.failedEventsList.filter(event => event !== action.payload)
            }
        }

        default:
        {
            return state;
        }
    }
};

export default widgetsReducer;


// WEBPACK FOOTER //
// src/main/content/dashboard/store/reducers/widgets.reducer.js